import styled from 'styled-components/macro';

import { DropdownRow } from '../dropdown-nav-button';

export const WelcomeRow = styled(DropdownRow)`
  display: block;
  color: ${({ theme }) => theme.palette.black[100]};
  padding: ${({ theme }) => theme.spacing(15)};
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;

  &:hover {
    background-color: ${({ theme }) => theme.palette.white};
  }
`;
